import { useEffect } from "react";

function RedirectToHtml() {
  useEffect(() => {
    window.location.replace("/front/GuiaContratacao.html");
  }, []);

  return null;
}

export default RedirectToHtml;